import { z } from "zod";

export const ENVIRONMENT_VARIABLES_SCHEMA = z.object({
	VITE_API_URL: z.string().url().min(1),
	VITE_NODE_ENV: z.enum(["development", "production"]),
	VITE_LIVEKIT_URL: z.string().min(1),
	/** Opt-in: serve the AI-media endpoints from msw fixtures instead of the real API. */
	VITE_MOCK_MEDIA: z.enum(["true", "false"]).optional(),
});
